const earthRadius = 6371;
const homeLat = 51.551565;
const homeLng = -0.058868;
const maxRadiusKm = 25;

const LONDON_BOROUGHS = [
  "Barking and Dagenham",
  "Barnet",
  "Bexley",
  "Brent",
  "Bromley",
  "Camden",
  "City of London",
  "Croydon",
  "Ealing",
  "Enfield",
  "Greenwich",
  "Hackney",
  "Hammersmith and Fulham",
  "Haringey",
  "Havering",
  "Hounslow",
  "Islington",
  "Kensington and Chelsea",
  "Kingston upon Thames",
  "Lambeth",
  "Lewisham",
  "Merton",
  "Newham",
  "Redbridge",
  "Richmond upon Thames",
  "Southwark",
  "Sutton",
  "Tower Hamlets",
  "Waltham Forest",
  "Wandsworth",
  "Westminster",
] as const;

export const isLondonBorough = (adminDistrict: string) =>
  LONDON_BOROUGHS.includes(adminDistrict.trim() as (typeof LONDON_BOROUGHS)[number]);

export const isInRadius = (adminDistrict: string, lat: any, lng: any) => {
  if (!isLondonBorough(adminDistrict)) {
    return false;
  }

  const deg2rad = (deg: number) => {
    return deg * (Math.PI / 180);
  };

  var dLat = deg2rad(lat - homeLat);
  var dLon = deg2rad(lng - homeLng);
  var a =
    Math.pow(Math.sin(dLat / 2), 2) +
    Math.cos(deg2rad(homeLat)) *
      Math.cos(deg2rad(homeLng)) *
      Math.pow(Math.sin(dLon / 2), 2);
  var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  var d = earthRadius * c; // Distance in km

  return d <= maxRadiusKm;
};
